"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    background: ", ";\n    margin: ", ";\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);\n    position: relative;\n"], ["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    background: ", ";\n    margin: ", ";\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);\n    position: relative;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require("../../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, function (props) {
    return props.color;
}, function (props) {
    return props.size;
}, function (props) {
    return props.weight;
}, function (props) {
    return props.background;
}, function (props) {
    return props.margin;
});

var MainNavMenu = function (_React$Component) {
    _inherits(MainNavMenu, _React$Component);

    function MainNavMenu() {
        _classCallCheck(this, MainNavMenu);

        return _possibleConstructorReturn(this, (MainNavMenu.__proto__ || Object.getPrototypeOf(MainNavMenu)).apply(this, arguments));
    }

    _createClass(MainNavMenu, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                Container,
                this.props,
                this.props.children
            );
        }
    }]);

    return MainNavMenu;
}(_react2.default.Component);

MainNavMenu.displayName = "MainNavMenu";

MainNavMenu.propTypes = {
    /** Font color - A valid css color value */
    color: _propTypes2.default.string,
    /** Font size - A valid css size value */
    size: _propTypes2.default.string,
    /** Font wieght - A valid css weight value */
    wieght: _propTypes2.default.string,
    /** The css background property for the navigation container */
    background: _propTypes2.default.string,
    /** The css margin property for the navigation container */
    margin: _propTypes2.default.string
};

MainNavMenu.defaultProps = {
    color: _theme.colors.black,
    size: "14px",
    weight: "bold",
    background: _theme.colors.white,
    margin: "0 0 " + _theme.spacing.margin + "em 0"
};

exports.default = MainNavMenu;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/navigation/MainNavMenu.js
// module id = 1016
// module chunks = 95715928098905 168707334958949